//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_DEVICE_MANAGEMENT_BASE_URL = new InjectionToken<string>('API_DEVICE_MANAGEMENT_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementAdvertiserApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get advertiser by id
     * @return Success
     */
    getAdvertiserById(id: string): Observable<Advertiser> {
        let url_ = this.baseUrl + "/api/Advertiser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvertiserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertiserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Advertiser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Advertiser>;
        }));
    }

    protected processGetAdvertiserById(response: HttpResponseBase): Observable<Advertiser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Advertiser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search advertisers
     * @param query (optional) 
     * @return Success
     */
    queryAdvertisers(query: AdvertiserQuery | null | undefined): Observable<AdvertiserQueryResponse> {
        let url_ = this.baseUrl + "/api/Advertiser/queryAdvertisers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryAdvertisers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryAdvertisers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertiserQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertiserQueryResponse>;
        }));
    }

    protected processQueryAdvertisers(response: HttpResponseBase): Observable<AdvertiserQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertiserQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementAppDeviceApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Retrieves status of a device using mac address
     * @param macAddress mac address of the opener
     * @return Success
     */
    getDetailsByMacAddress(macAddress: string): Observable<AppDeviceDetails> {
        let url_ = this.baseUrl + "/api/app/device/byMac/{macAddress}";
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{macAddress}", encodeURIComponent("" + macAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsByMacAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsByMacAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppDeviceDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppDeviceDetails>;
        }));
    }

    protected processGetDetailsByMacAddress(response: HttpResponseBase): Observable<AppDeviceDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDeviceDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves status of a device using serial number (better use this one, better performance)
     * @param serialNumber serial number of the opener
     * @return Success
     */
    getDetails(serialNumber: string): Observable<AppDeviceDetails> {
        let url_ = this.baseUrl + "/api/app/device/{serialNumber}";
        if (serialNumber === undefined || serialNumber === null)
            throw new Error("The parameter 'serialNumber' must be defined.");
        url_ = url_.replace("{serialNumber}", encodeURIComponent("" + serialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppDeviceDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppDeviceDetails>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<AppDeviceDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDeviceDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get outlet id from device by mac address
     * @return Success
     */
    getDeviceOutletTag(macAddress: string): Observable<string> {
        let url_ = this.baseUrl + "/api/app/device/outlet-tag/byMac/{macAddress}";
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{macAddress}", encodeURIComponent("" + macAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceOutletTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceOutletTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDeviceOutletTag(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search for devices in IoT Fleet indexing.
     * @param filters (optional) If there is any value in the SeriaNumber array it will first retrieve those devices and then apply the filter in memory.
    You can specify a maximum of 100 serial numbers.
    Because IoT Fleet indexing suports only five search criterias and we use one to filter the environment you can specify a maximum of four search criterias (excluding serial numbers).
     * @return Success
     */
    searchDevices(filters: DeviceFilters | null | undefined): Observable<FleetIndexResponse> {
        let url_ = this.baseUrl + "/api/app/device/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FleetIndexResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FleetIndexResponse>;
        }));
    }

    protected processSearchDevices(response: HttpResponseBase): Observable<FleetIndexResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FleetIndexResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            let resultData410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result410 = ClientErrorMessageResponse.fromJS(resultData410);
            return throwException("Client Error", status, _responseText, _headers, result410);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementAppRedirectApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get redirect link
     * @return Success
     */
    getRedirectLink(macAddress: string): Observable<void> {
        let url_ = this.baseUrl + "/api/AppRedirect/{macAddress}";
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{macAddress}", encodeURIComponent("" + macAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRedirectLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedirectLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRedirectLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementBarApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get bar by id.
     * @return Success
     */
    getBarById(barId: number): Observable<Bar> {
        let url_ = this.baseUrl + "/api/Bar/getBarById/{barId}";
        if (barId === undefined || barId === null)
            throw new Error("The parameter 'barId' must be defined.");
        url_ = url_.replace("{barId}", encodeURIComponent("" + barId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bar>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bar>;
        }));
    }

    protected processGetBarById(response: HttpResponseBase): Observable<Bar> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bar.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search bars.
     * @param query (optional) 
     * @return Success
     */
    queryBars(query: BarQuery | null | undefined): Observable<BarQueryResponse> {
        let url_ = this.baseUrl + "/api/Bar/queryBars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryBars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryBars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarQueryResponse>;
        }));
    }

    protected processQueryBars(response: HttpResponseBase): Observable<BarQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementDeviceApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get avilable device types defined in IoT Core.
     * @return Success
     */
    getDeviceTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Device/devicetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDeviceTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search for devices in IoT Fleet indexing.
     * @param filters (optional) If there is any value in the SeriaNumber array it will first retrieve those devices and then apply the filter in memory.
    You can specify a maximum of 100 serial numbers.
    Because IoT Fleet indexing suports only five search criterias and we use one to filter the environment you can specify a maximum of four search criterias (excluding serial numbers).
     * @return Success
     */
    searchDevices2(filters: DeviceFilters | null | undefined): Observable<FleetIndexResponse> {
        let url_ = this.baseUrl + "/api/Device/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDevices2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDevices2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FleetIndexResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FleetIndexResponse>;
        }));
    }

    protected processSearchDevices2(response: HttpResponseBase): Observable<FleetIndexResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FleetIndexResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            let resultData410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result410 = ClientErrorMessageResponse.fromJS(resultData410);
            return throwException("Client Error", status, _responseText, _headers, result410);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Count no. of devices in IoT Fleet indexing.
     * @param filters (optional) If there is any value in the SeriaNumber array it will first retrieve those devices and then apply the filter in memory.
    You can specify a maximum of 100 serial numbers.
    Because IoT Fleet indexing suports only five search criterias and we use one to filter the environment you can specify a maximum of four search criterias (excluding serial numbers).
     * @return Success
     */
    countDevices(filters: DeviceFilters | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountDevices(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the info for a device.
     * @param deviceId (optional) The device ID is the serial number for devices that use a firmware that can read/send it and the MAC address for older firmwares.
     * @return Success
     */
    getDeviceById(deviceId: string | null | undefined): Observable<Device> {
        let url_ = this.baseUrl + "/api/Device?";
        if (deviceId !== undefined && deviceId !== null)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Device>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Device>;
        }));
    }

    protected processGetDeviceById(response: HttpResponseBase): Observable<Device> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of suggested serials based on the first characters.
     * @param serialPrefix (optional) The first characters for which to perform the search.
     * @return Success
     */
    suggestSerial(serialPrefix: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Device/suggest-serial?";
        if (serialPrefix !== undefined && serialPrefix !== null)
            url_ += "serialPrefix=" + encodeURIComponent("" + serialPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggestSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggestSerial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processSuggestSerial(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of suggested MAC addresses based on the first characters.
     * @param prefix (optional) The first characters for which to perform the search.
     * @return Success
     */
    suggestMac(prefix: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Device/suggest-mac?";
        if (prefix !== undefined && prefix !== null)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggestMac(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggestMac(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processSuggestMac(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set outlet attribute for a specific device
     * @param device (optional) 
     * @return Success
     */
    setDeviceOutletAttribute(device: Device | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/setDeviceOutletAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDeviceOutletAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDeviceOutletAttribute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDeviceOutletAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add outlet attribute for a specific device and user
     * @param userId (optional) 
     * @param device (optional) 
     * @return Success
     */
    setDeviceOutletAttributeForUser(userId: string | null | undefined, device: Device | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/setDeviceOutletAttributeForUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDeviceOutletAttributeForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDeviceOutletAttributeForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDeviceOutletAttributeForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set advertiser attribute for a specific device
     * @param device (optional) 
     * @return Success
     */
    setDeviceAdvertiserAttribute(device: Device | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/setDeviceAdvertiserAttribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDeviceAdvertiserAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDeviceAdvertiserAttribute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDeviceAdvertiserAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get the number of assigned opener in period
     * @param outletId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    countAssignedOpenerInPeriod(outletId: string | null | undefined, from: Date | null | undefined, to: Date | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/CountAssignedOpenerInPeriod?";
        if (outletId !== undefined && outletId !== null)
            url_ += "outletId=" + encodeURIComponent("" + outletId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountAssignedOpenerInPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountAssignedOpenerInPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountAssignedOpenerInPeriod(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the firmware history for a device.
     * @param deviceId The device ID is the serial number for devices that use a firmware that can read/send it and the MAC address for older firmwares.
     * @return Success
     */
    getDeviceFirmwareHistory(deviceId: string): Observable<FirmwareHistoryModel[]> {
        let url_ = this.baseUrl + "/api/Device/firmware-history/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceFirmwareHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceFirmwareHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareHistoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareHistoryModel[]>;
        }));
    }

    protected processGetDeviceFirmwareHistory(response: HttpResponseBase): Observable<FirmwareHistoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirmwareHistoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assign the desired firmware to a list of devices to perform OTA update.
     * @param request (optional) 
     * @return Success
     */
    assignFirmwareTask(request: AssignFirmwareBulkRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Device/assign-firmware-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignFirmwareTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignFirmwareTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAssignFirmwareTask(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] ? ModelStateEntry.fromJS(resultData400[key]) : new ModelStateEntry();
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementDeviceManagementIntegrationApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get the info for a device.
     * @param deviceId The device ID is the serial number for devices that use a firmware that can read/send it and the MAC address for older firmwares.
     * @return Success
     */
    getDeviceByIdIntegration(deviceId: string): Observable<Device> {
        let url_ = this.baseUrl + "/api/DeviceManagementIntegration/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceByIdIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceByIdIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Device>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Device>;
        }));
    }

    protected processGetDeviceByIdIntegration(response: HttpResponseBase): Observable<Device> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Device.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementFirmwareApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get a list of available firmwares.
     * @return Success
     */
    getAllFirmwares(): Observable<FirmwareInfo[]> {
        let url_ = this.baseUrl + "/api/Firmware";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFirmwares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFirmwares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareInfo[]>;
        }));
    }

    protected processGetAllFirmwares(response: HttpResponseBase): Observable<FirmwareInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirmwareInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or update a firmware.
     * @param firmwareInfo (optional) The info of the firmware.
     * @return Success
     */
    createOrUpdateFirmware(firmwareInfo: FirmwareInfo | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Firmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(firmwareInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateFirmware(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a firmware.
     * @param firmwareId (optional) The id of the firmware.
     * @return Success
     */
    deleteFirmware(firmwareId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Firmware?";
        if (firmwareId !== undefined && firmwareId !== null)
            url_ += "firmwareId=" + encodeURIComponent("" + firmwareId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFirmware(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the info for a firmware.
     * @param firmwareId The id of the firmware.
     * @return Success
     */
    getFirmwareById(firmwareId: string): Observable<FirmwareInfo> {
        let url_ = this.baseUrl + "/api/Firmware/{firmwareId}";
        if (firmwareId === undefined || firmwareId === null)
            throw new Error("The parameter 'firmwareId' must be defined.");
        url_ = url_.replace("{firmwareId}", encodeURIComponent("" + firmwareId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirmwareById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirmwareById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirmwareInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirmwareInfo>;
        }));
    }

    protected processGetFirmwareById(response: HttpResponseBase): Observable<FirmwareInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirmwareInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the download URL for a firmware.
     * @param firmwareId (optional) The id of the firmware.
     * @return Success
     */
    getFirmwareDownloadUrl(firmwareId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Firmware/firmware-download-url?";
        if (firmwareId !== undefined && firmwareId !== null)
            url_ += "firmwareId=" + encodeURIComponent("" + firmwareId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirmwareDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirmwareDownloadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFirmwareDownloadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the download URL for the default firmware.
     * @return Success
     */
    getDefaultFirmwareUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/Firmware/default-firmware-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultFirmwareUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultFirmwareUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultFirmwareUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementRegistrationApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get the list of the registration groups created so far.
     * @return Success
     */
    getRegistrationGroups(): Observable<RegistrationGroup[]> {
        let url_ = this.baseUrl + "/api/Registration/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationGroup[]>;
        }));
    }

    protected processGetRegistrationGroups(response: HttpResponseBase): Observable<RegistrationGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a registration group.
     * @param groupName The name of the group.
     * @return Success
     */
    deleteRegistrationGroup(groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Registration/{groupName}";
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRegistrationGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRegistrationGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRegistrationGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start a asynchronous task to register a new group. Returns the name of the asynchronous task.
     * @param request (optional) The name of the group to register.
     * @return Success
     */
    startRegisterTask(request: RegisterBulkRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Registration/startRegisterTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartRegisterTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartRegisterTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartRegisterTask(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : <any>null;
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the status of the asynchronous task started to register a new group.
     * @param executionName The name of the asynchronous task.
     * @return Success
     */
    getRegisterTaskResult(executionName: string): Observable<RegisterBulkResponseStateMachineExecutionResult> {
        let url_ = this.baseUrl + "/api/Registration/registerTaskResult/{executionName}";
        if (executionName === undefined || executionName === null)
            throw new Error("The parameter 'executionName' must be defined.");
        url_ = url_.replace("{executionName}", encodeURIComponent("" + executionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisterTaskResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisterTaskResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterBulkResponseStateMachineExecutionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterBulkResponseStateMachineExecutionResult>;
        }));
    }

    protected processGetRegisterTaskResult(response: HttpResponseBase): Observable<RegisterBulkResponseStateMachineExecutionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterBulkResponseStateMachineExecutionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Register or update a single IoT device. GroupName and DeviceType are optional.
     * @param registerDeviceRequest (optional) 
     * @return Success
     */
    registerDevice(registerDeviceRequest: RegisterDeviceRequest | null | undefined): Observable<RegisterDeviceResponse> {
        let url_ = this.baseUrl + "/api/Registration/registerDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerDeviceRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterDeviceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterDeviceResponse>;
        }));
    }

    protected processRegisterDevice(response: HttpResponseBase): Observable<RegisterDeviceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterDeviceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceManagementVersionApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_DEVICE_MANAGEMENT_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/staging-device-management";
    }

    /**
     * Get the API version of the device management sub-domain..
     * @return Success
     */
    getVersionInfo(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Helper method used to test exception handling.
     * @return Success
     */
    testException(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTestException(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Helper method
     * @return Success
     */
    myTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/Version/myversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMyTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class Advertiser implements IAdvertiser {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    appToRedirect?: string | undefined;
    organizationIds?: string[] | undefined;
    organizationNames?: string[] | undefined;
    dataConnection?: ConsumerDataConnection | undefined;

    constructor(data?: IAdvertiser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.photoFull = _data["photoFull"];
            this.photoThumb = _data["photoThumb"];
            this.appToRedirect = _data["appToRedirect"];
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            if (Array.isArray(_data["organizationNames"])) {
                this.organizationNames = [] as any;
                for (let item of _data["organizationNames"])
                    this.organizationNames!.push(item);
            }
            this.dataConnection = _data["dataConnection"] ? ConsumerDataConnection.fromJS(_data["dataConnection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Advertiser {
        data = typeof data === 'object' ? data : {};
        let result = new Advertiser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["photoFull"] = this.photoFull;
        data["photoThumb"] = this.photoThumb;
        data["appToRedirect"] = this.appToRedirect;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.organizationNames)) {
            data["organizationNames"] = [];
            for (let item of this.organizationNames)
                data["organizationNames"].push(item);
        }
        data["dataConnection"] = this.dataConnection ? this.dataConnection.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdvertiser {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    appToRedirect?: string | undefined;
    organizationIds?: string[] | undefined;
    organizationNames?: string[] | undefined;
    dataConnection?: ConsumerDataConnection | undefined;
}

export class AdvertiserQuery implements IAdvertiserQuery {
    names?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IAdvertiserQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): AdvertiserQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IAdvertiserQuery {
    names?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;
}

export class AdvertiserQueryResponse implements IAdvertiserQueryResponse {
    items?: Advertiser[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IAdvertiserQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Advertiser.fromJS(item));
            }
            this.total = _data["total"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): AdvertiserQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertiserQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IAdvertiserQueryResponse {
    items?: Advertiser[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;
}

/** Device Details model for Bartender App */
export class AppDeviceDetails implements IAppDeviceDetails {
    /** serial number of the device. If it is an older device without serialnumber, this will be filled-in with MAC */
    serialNumber?: string | undefined;
    /** Opener mac address */
    mac?: string | undefined;
    /** Battery level reported by the device */
    batteryLevel?: number | undefined;
    /** Battery in percentage computed by device management using scale
RED: The battery is less than 20% full (3500-3600 mV)
YELLOW: The battery is between 20 and 80% full(3600-3900 mV)
GREEN: The battery is more than 80% full(3900-4000 mV) */
    batteryPercent?: number | undefined;
    /** Last time the device details were updated */
    updatedAt?: Date | undefined;
    /** SSID of the last used wifi network */
    wifiSSID?: string | undefined;
    /** Time to connect to the wifi (wifiConnectDone - wifiConnectStart) */
    wifiTime?: number | undefined;
    /** RSSI of the last uploaded image */
    rssi?: number | undefined;
    /** WiFi signal strength of the last uploaded image */
    signalStrength?: number | undefined;

    constructor(data?: IAppDeviceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.mac = _data["mac"];
            this.batteryLevel = _data["batteryLevel"];
            this.batteryPercent = _data["batteryPercent"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.wifiSSID = _data["wifiSSID"];
            this.wifiTime = _data["wifiTime"];
            this.rssi = _data["rssi"];
            this.signalStrength = _data["signalStrength"];
        }
    }

    static fromJS(data: any): AppDeviceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AppDeviceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["mac"] = this.mac;
        data["batteryLevel"] = this.batteryLevel;
        data["batteryPercent"] = this.batteryPercent;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["wifiSSID"] = this.wifiSSID;
        data["wifiTime"] = this.wifiTime;
        data["rssi"] = this.rssi;
        data["signalStrength"] = this.signalStrength;
        return data;
    }
}

/** Device Details model for Bartender App */
export interface IAppDeviceDetails {
    /** serial number of the device. If it is an older device without serialnumber, this will be filled-in with MAC */
    serialNumber?: string | undefined;
    /** Opener mac address */
    mac?: string | undefined;
    /** Battery level reported by the device */
    batteryLevel?: number | undefined;
    /** Battery in percentage computed by device management using scale
RED: The battery is less than 20% full (3500-3600 mV)
YELLOW: The battery is between 20 and 80% full(3600-3900 mV)
GREEN: The battery is more than 80% full(3900-4000 mV) */
    batteryPercent?: number | undefined;
    /** Last time the device details were updated */
    updatedAt?: Date | undefined;
    /** SSID of the last used wifi network */
    wifiSSID?: string | undefined;
    /** Time to connect to the wifi (wifiConnectDone - wifiConnectStart) */
    wifiTime?: number | undefined;
    /** RSSI of the last uploaded image */
    rssi?: number | undefined;
    /** WiFi signal strength of the last uploaded image */
    signalStrength?: number | undefined;
}

export class AssignFirmwareBulkRequest implements IAssignFirmwareBulkRequest {
    filter?: DeviceFilters | undefined;
    all?: boolean | undefined;
    include?: string[] | undefined;
    exclude?: string[] | undefined;
    total?: number | undefined;
    user?: string | undefined;
    firmware?: FirmwareInfo | undefined;

    constructor(data?: IAssignFirmwareBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? DeviceFilters.fromJS(_data["filter"]) : <any>undefined;
            this.all = _data["all"];
            if (Array.isArray(_data["include"])) {
                this.include = [] as any;
                for (let item of _data["include"])
                    this.include!.push(item);
            }
            if (Array.isArray(_data["exclude"])) {
                this.exclude = [] as any;
                for (let item of _data["exclude"])
                    this.exclude!.push(item);
            }
            this.total = _data["total"];
            this.user = _data["user"];
            this.firmware = _data["firmware"] ? FirmwareInfo.fromJS(_data["firmware"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignFirmwareBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFirmwareBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["all"] = this.all;
        if (Array.isArray(this.include)) {
            data["include"] = [];
            for (let item of this.include)
                data["include"].push(item);
        }
        if (Array.isArray(this.exclude)) {
            data["exclude"] = [];
            for (let item of this.exclude)
                data["exclude"].push(item);
        }
        data["total"] = this.total;
        data["user"] = this.user;
        data["firmware"] = this.firmware ? this.firmware.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignFirmwareBulkRequest {
    filter?: DeviceFilters | undefined;
    all?: boolean | undefined;
    include?: string[] | undefined;
    exclude?: string[] | undefined;
    total?: number | undefined;
    user?: string | undefined;
    firmware?: FirmwareInfo | undefined;
}

export class Bar implements IBar {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    organizationId?: number | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    officialAddress?: string | undefined;
    formattedAddress?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    streetAddress?: string | undefined;
    route?: string | undefined;
    streetNumber?: string | undefined;
    administrativeAreaL1?: string | undefined;
    administrativeAreaL1ShortName?: string | undefined;
    administrativeAreaL2?: string | undefined;
    administrativeAreaL2ShortName?: string | undefined;
    administrativeAreaL3?: string | undefined;
    administrativeAreaL3ShortName?: string | undefined;
    administrativeAreaL4?: string | undefined;
    administrativeAreaL4ShortName?: string | undefined;
    administrativeAreaL5?: string | undefined;
    administrativeAreaL5ShortName?: string | undefined;
    locality?: string | undefined;
    sublocality?: string | undefined;
    postalCode?: string | undefined;
    neighborhood?: string | undefined;
    placeId?: string | undefined;
    plusCodeGlobal?: string | undefined;
    plusCodeLocal?: string | undefined;
    timeZoneId?: string | undefined;
    timeZoneName?: string | undefined;
    state?: string | undefined;
    insightsId?: string | undefined;
    slug?: string | undefined;
    createdByInsightsUserId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    source?: string | undefined;
    timestamp?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    externalId?: string | undefined;
    vendorName?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    dataValidationNote?: string | undefined;
    lastValidationDate?: Date | undefined;

    constructor(data?: IBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.organizationId = _data["organizationId"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.officialAddress = _data["officialAddress"];
            this.formattedAddress = _data["formattedAddress"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.streetAddress = _data["streetAddress"];
            this.route = _data["route"];
            this.streetNumber = _data["streetNumber"];
            this.administrativeAreaL1 = _data["administrativeAreaL1"];
            this.administrativeAreaL1ShortName = _data["administrativeAreaL1ShortName"];
            this.administrativeAreaL2 = _data["administrativeAreaL2"];
            this.administrativeAreaL2ShortName = _data["administrativeAreaL2ShortName"];
            this.administrativeAreaL3 = _data["administrativeAreaL3"];
            this.administrativeAreaL3ShortName = _data["administrativeAreaL3ShortName"];
            this.administrativeAreaL4 = _data["administrativeAreaL4"];
            this.administrativeAreaL4ShortName = _data["administrativeAreaL4ShortName"];
            this.administrativeAreaL5 = _data["administrativeAreaL5"];
            this.administrativeAreaL5ShortName = _data["administrativeAreaL5ShortName"];
            this.locality = _data["locality"];
            this.sublocality = _data["sublocality"];
            this.postalCode = _data["postalCode"];
            this.neighborhood = _data["neighborhood"];
            this.placeId = _data["placeId"];
            this.plusCodeGlobal = _data["plusCodeGlobal"];
            this.plusCodeLocal = _data["plusCodeLocal"];
            this.timeZoneId = _data["timeZoneId"];
            this.timeZoneName = _data["timeZoneName"];
            this.state = _data["state"];
            this.insightsId = _data["insightsId"];
            this.slug = _data["slug"];
            this.createdByInsightsUserId = _data["createdByInsightsUserId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.source = _data["source"];
            this.timestamp = _data["timestamp"];
            this.photoFull = _data["photoFull"];
            this.photoThumb = _data["photoThumb"];
            this.externalId = _data["externalId"];
            this.vendorName = _data["vendorName"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.dataValidationNote = _data["dataValidationNote"];
            this.lastValidationDate = _data["lastValidationDate"] ? new Date(_data["lastValidationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Bar {
        data = typeof data === 'object' ? data : {};
        let result = new Bar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["organizationId"] = this.organizationId;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["officialAddress"] = this.officialAddress;
        data["formattedAddress"] = this.formattedAddress;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["streetAddress"] = this.streetAddress;
        data["route"] = this.route;
        data["streetNumber"] = this.streetNumber;
        data["administrativeAreaL1"] = this.administrativeAreaL1;
        data["administrativeAreaL1ShortName"] = this.administrativeAreaL1ShortName;
        data["administrativeAreaL2"] = this.administrativeAreaL2;
        data["administrativeAreaL2ShortName"] = this.administrativeAreaL2ShortName;
        data["administrativeAreaL3"] = this.administrativeAreaL3;
        data["administrativeAreaL3ShortName"] = this.administrativeAreaL3ShortName;
        data["administrativeAreaL4"] = this.administrativeAreaL4;
        data["administrativeAreaL4ShortName"] = this.administrativeAreaL4ShortName;
        data["administrativeAreaL5"] = this.administrativeAreaL5;
        data["administrativeAreaL5ShortName"] = this.administrativeAreaL5ShortName;
        data["locality"] = this.locality;
        data["sublocality"] = this.sublocality;
        data["postalCode"] = this.postalCode;
        data["neighborhood"] = this.neighborhood;
        data["placeId"] = this.placeId;
        data["plusCodeGlobal"] = this.plusCodeGlobal;
        data["plusCodeLocal"] = this.plusCodeLocal;
        data["timeZoneId"] = this.timeZoneId;
        data["timeZoneName"] = this.timeZoneName;
        data["state"] = this.state;
        data["insightsId"] = this.insightsId;
        data["slug"] = this.slug;
        data["createdByInsightsUserId"] = this.createdByInsightsUserId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["timestamp"] = this.timestamp;
        data["photoFull"] = this.photoFull;
        data["photoThumb"] = this.photoThumb;
        data["externalId"] = this.externalId;
        data["vendorName"] = this.vendorName;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["dataValidationNote"] = this.dataValidationNote;
        data["lastValidationDate"] = this.lastValidationDate ? this.lastValidationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBar {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    organizationId?: number | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    officialAddress?: string | undefined;
    formattedAddress?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    streetAddress?: string | undefined;
    route?: string | undefined;
    streetNumber?: string | undefined;
    administrativeAreaL1?: string | undefined;
    administrativeAreaL1ShortName?: string | undefined;
    administrativeAreaL2?: string | undefined;
    administrativeAreaL2ShortName?: string | undefined;
    administrativeAreaL3?: string | undefined;
    administrativeAreaL3ShortName?: string | undefined;
    administrativeAreaL4?: string | undefined;
    administrativeAreaL4ShortName?: string | undefined;
    administrativeAreaL5?: string | undefined;
    administrativeAreaL5ShortName?: string | undefined;
    locality?: string | undefined;
    sublocality?: string | undefined;
    postalCode?: string | undefined;
    neighborhood?: string | undefined;
    placeId?: string | undefined;
    plusCodeGlobal?: string | undefined;
    plusCodeLocal?: string | undefined;
    timeZoneId?: string | undefined;
    timeZoneName?: string | undefined;
    state?: string | undefined;
    insightsId?: string | undefined;
    slug?: string | undefined;
    createdByInsightsUserId?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    source?: string | undefined;
    timestamp?: string | undefined;
    photoFull?: string | undefined;
    photoThumb?: string | undefined;
    externalId?: string | undefined;
    vendorName?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    dataValidationNote?: string | undefined;
    lastValidationDate?: Date | undefined;
}

export class BarQuery implements IBarQuery {
    names?: string[] | undefined;
    state?: string | undefined;
    organizationId?: number | undefined;
    externalId?: string | undefined;
    vendorName?: string | undefined;
    administrativeAreaL1s?: string[] | undefined;
    administrativeAreaL2s?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IBarQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
            this.state = _data["state"];
            this.organizationId = _data["organizationId"];
            this.externalId = _data["externalId"];
            this.vendorName = _data["vendorName"];
            if (Array.isArray(_data["administrativeAreaL1s"])) {
                this.administrativeAreaL1s = [] as any;
                for (let item of _data["administrativeAreaL1s"])
                    this.administrativeAreaL1s!.push(item);
            }
            if (Array.isArray(_data["administrativeAreaL2s"])) {
                this.administrativeAreaL2s = [] as any;
                for (let item of _data["administrativeAreaL2s"])
                    this.administrativeAreaL2s!.push(item);
            }
            this.skip = _data["skip"];
            this.maxItems = _data["maxItems"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): BarQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BarQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        data["state"] = this.state;
        data["organizationId"] = this.organizationId;
        data["externalId"] = this.externalId;
        data["vendorName"] = this.vendorName;
        if (Array.isArray(this.administrativeAreaL1s)) {
            data["administrativeAreaL1s"] = [];
            for (let item of this.administrativeAreaL1s)
                data["administrativeAreaL1s"].push(item);
        }
        if (Array.isArray(this.administrativeAreaL2s)) {
            data["administrativeAreaL2s"] = [];
            for (let item of this.administrativeAreaL2s)
                data["administrativeAreaL2s"].push(item);
        }
        data["skip"] = this.skip;
        data["maxItems"] = this.maxItems;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IBarQuery {
    names?: string[] | undefined;
    state?: string | undefined;
    organizationId?: number | undefined;
    externalId?: string | undefined;
    vendorName?: string | undefined;
    administrativeAreaL1s?: string[] | undefined;
    administrativeAreaL2s?: string[] | undefined;
    skip?: number | undefined;
    maxItems?: number | undefined;
    nextToken?: string | undefined;
}

export class BarQueryResponse implements IBarQueryResponse {
    items?: Bar[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;

    constructor(data?: IBarQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Bar.fromJS(item));
            }
            this.total = _data["total"];
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): BarQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BarQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IBarQueryResponse {
    items?: Bar[] | undefined;
    total?: number | undefined;
    nextToken?: string | undefined;
}

export class ClientErrorMessageResponse implements IClientErrorMessageResponse {
    message?: string | undefined;

    constructor(data?: IClientErrorMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ClientErrorMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientErrorMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IClientErrorMessageResponse {
    message?: string | undefined;
}

export class ConsumerDataConnection implements IConsumerDataConnection {
    connectionTemplate?: string | undefined;
    status?: DataConnectionStatus | undefined;
    data?: { [key: string]: any; } | undefined;
    consumptionAuthorization?: ConsumptionAuthorization | undefined;
    type?: DataConnectionType | undefined;
    url?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IConsumerDataConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionTemplate = _data["connectionTemplate"];
            this.status = _data["status"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.consumptionAuthorization = _data["consumptionAuthorization"] ? ConsumptionAuthorization.fromJS(_data["consumptionAuthorization"]) : <any>undefined;
            this.type = _data["type"];
            this.url = _data["url"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ConsumerDataConnection {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDataConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionTemplate"] = this.connectionTemplate;
        data["status"] = this.status;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["consumptionAuthorization"] = this.consumptionAuthorization ? this.consumptionAuthorization.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["url"] = this.url;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IConsumerDataConnection {
    connectionTemplate?: string | undefined;
    status?: DataConnectionStatus | undefined;
    data?: { [key: string]: any; } | undefined;
    consumptionAuthorization?: ConsumptionAuthorization | undefined;
    type?: DataConnectionType | undefined;
    url?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
}

export class ConsumptionAuthorization implements IConsumptionAuthorization {
    consumptionApiKey?: string | undefined;
    consumptionApiSecret?: string | undefined;

    constructor(data?: IConsumptionAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumptionApiKey = _data["consumptionApiKey"];
            this.consumptionApiSecret = _data["consumptionApiSecret"];
        }
    }

    static fromJS(data: any): ConsumptionAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumptionApiKey"] = this.consumptionApiKey;
        data["consumptionApiSecret"] = this.consumptionApiSecret;
        return data;
    }
}

export interface IConsumptionAuthorization {
    consumptionApiKey?: string | undefined;
    consumptionApiSecret?: string | undefined;
}

export enum DataConnectionStatus {
    Verified = "Verified",
    NotVerified = "NotVerified",
}

export enum DataConnectionType {
    Salesforce = "Salesforce",
}

export class Device implements IDevice {
    name?: string | undefined;
    type?: string | undefined;
    attributes?: DeviceAttributes | undefined;
    status?: DeviceStatus | undefined;
    isConnected?: boolean | undefined;
    readonly pendingOTAUpdate?: boolean | undefined;
    readonly createdAt?: Date | undefined;
    readonly updatedAt?: Date | undefined;
    version?: number | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.attributes = _data["attributes"] ? DeviceAttributes.fromJS(_data["attributes"]) : <any>undefined;
            this.status = _data["status"] ? DeviceStatus.fromJS(_data["status"]) : <any>undefined;
            this.isConnected = _data["isConnected"];
            (<any>this).pendingOTAUpdate = _data["pendingOTAUpdate"];
            (<any>this).createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            (<any>this).updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["isConnected"] = this.isConnected;
        data["pendingOTAUpdate"] = this.pendingOTAUpdate;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["version"] = this.version;
        return data;
    }
}

export interface IDevice {
    name?: string | undefined;
    type?: string | undefined;
    attributes?: DeviceAttributes | undefined;
    status?: DeviceStatus | undefined;
    isConnected?: boolean | undefined;
    pendingOTAUpdate?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    version?: number | undefined;
}

export class DeviceAttributes implements IDeviceAttributes {
    macAddress?: string | undefined;
    hpi?: string | undefined;
    qcDate?: Date | undefined;
    lifeCycleStatus?: DeviceLifeCycleStatus | undefined;
    createdAt?: Date | undefined;
    environment?: string | undefined;
    openerGroup?: string | undefined;
    outletId?: string | undefined;
    advertiserId?: string | undefined;

    constructor(data?: IDeviceAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.macAddress = _data["macAddress"];
            this.hpi = _data["hpi"];
            this.qcDate = _data["qcDate"] ? new Date(_data["qcDate"].toString()) : <any>undefined;
            this.lifeCycleStatus = _data["lifeCycleStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.environment = _data["environment"];
            this.openerGroup = _data["openerGroup"];
            this.outletId = _data["outletId"];
            this.advertiserId = _data["advertiserId"];
        }
    }

    static fromJS(data: any): DeviceAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["macAddress"] = this.macAddress;
        data["hpi"] = this.hpi;
        data["qcDate"] = this.qcDate ? this.qcDate.toISOString() : <any>undefined;
        data["lifeCycleStatus"] = this.lifeCycleStatus;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["environment"] = this.environment;
        data["openerGroup"] = this.openerGroup;
        data["outletId"] = this.outletId;
        data["advertiserId"] = this.advertiserId;
        return data;
    }
}

export interface IDeviceAttributes {
    macAddress?: string | undefined;
    hpi?: string | undefined;
    qcDate?: Date | undefined;
    lifeCycleStatus?: DeviceLifeCycleStatus | undefined;
    createdAt?: Date | undefined;
    environment?: string | undefined;
    openerGroup?: string | undefined;
    outletId?: string | undefined;
    advertiserId?: string | undefined;
}

export class DeviceFilters implements IDeviceFilters {
    seriaNumber?: string[] | undefined;
    mac?: string[] | undefined;
    hpi?: string[] | undefined;
    currentFirmware?: string[] | undefined;
    desiredFirmware?: string[] | undefined;
    isFirmwareUpdated?: boolean | undefined;
    imagesRemaining?: number | undefined;
    outletId?: string | undefined;
    advertiserId?: string | undefined;
    pageSize?: number | undefined;
    nextToken?: string | undefined;
    fromDate?: Date | undefined;

    constructor(data?: IDeviceFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seriaNumber"])) {
                this.seriaNumber = [] as any;
                for (let item of _data["seriaNumber"])
                    this.seriaNumber!.push(item);
            }
            if (Array.isArray(_data["mac"])) {
                this.mac = [] as any;
                for (let item of _data["mac"])
                    this.mac!.push(item);
            }
            if (Array.isArray(_data["hpi"])) {
                this.hpi = [] as any;
                for (let item of _data["hpi"])
                    this.hpi!.push(item);
            }
            if (Array.isArray(_data["currentFirmware"])) {
                this.currentFirmware = [] as any;
                for (let item of _data["currentFirmware"])
                    this.currentFirmware!.push(item);
            }
            if (Array.isArray(_data["desiredFirmware"])) {
                this.desiredFirmware = [] as any;
                for (let item of _data["desiredFirmware"])
                    this.desiredFirmware!.push(item);
            }
            this.isFirmwareUpdated = _data["isFirmwareUpdated"];
            this.imagesRemaining = _data["imagesRemaining"];
            this.outletId = _data["outletId"];
            this.advertiserId = _data["advertiserId"];
            this.pageSize = _data["pageSize"];
            this.nextToken = _data["nextToken"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seriaNumber)) {
            data["seriaNumber"] = [];
            for (let item of this.seriaNumber)
                data["seriaNumber"].push(item);
        }
        if (Array.isArray(this.mac)) {
            data["mac"] = [];
            for (let item of this.mac)
                data["mac"].push(item);
        }
        if (Array.isArray(this.hpi)) {
            data["hpi"] = [];
            for (let item of this.hpi)
                data["hpi"].push(item);
        }
        if (Array.isArray(this.currentFirmware)) {
            data["currentFirmware"] = [];
            for (let item of this.currentFirmware)
                data["currentFirmware"].push(item);
        }
        if (Array.isArray(this.desiredFirmware)) {
            data["desiredFirmware"] = [];
            for (let item of this.desiredFirmware)
                data["desiredFirmware"].push(item);
        }
        data["isFirmwareUpdated"] = this.isFirmwareUpdated;
        data["imagesRemaining"] = this.imagesRemaining;
        data["outletId"] = this.outletId;
        data["advertiserId"] = this.advertiserId;
        data["pageSize"] = this.pageSize;
        data["nextToken"] = this.nextToken;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceFilters {
    seriaNumber?: string[] | undefined;
    mac?: string[] | undefined;
    hpi?: string[] | undefined;
    currentFirmware?: string[] | undefined;
    desiredFirmware?: string[] | undefined;
    isFirmwareUpdated?: boolean | undefined;
    imagesRemaining?: number | undefined;
    outletId?: string | undefined;
    advertiserId?: string | undefined;
    pageSize?: number | undefined;
    nextToken?: string | undefined;
    fromDate?: Date | undefined;
}

export enum DeviceLifeCycleStatus {
    Registered = "Registered",
    Activated = "Activated",
    InUse = "InUse",
    Retired = "Retired",
}

export class DeviceStatus implements IDeviceStatus {
    reported?: DeviceStatusReported | undefined;
    desired?: DeviceStatusDesired | undefined;
    shadowVersion?: number | undefined;
    timestamp?: Date | undefined;
    reportedFirmwareTimestamp?: Date | undefined;

    constructor(data?: IDeviceStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reported = _data["reported"] ? DeviceStatusReported.fromJS(_data["reported"]) : <any>undefined;
            this.desired = _data["desired"] ? DeviceStatusDesired.fromJS(_data["desired"]) : <any>undefined;
            this.shadowVersion = _data["shadowVersion"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.reportedFirmwareTimestamp = _data["reportedFirmwareTimestamp"] ? new Date(_data["reportedFirmwareTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reported"] = this.reported ? this.reported.toJSON() : <any>undefined;
        data["desired"] = this.desired ? this.desired.toJSON() : <any>undefined;
        data["shadowVersion"] = this.shadowVersion;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["reportedFirmwareTimestamp"] = this.reportedFirmwareTimestamp ? this.reportedFirmwareTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceStatus {
    reported?: DeviceStatusReported | undefined;
    desired?: DeviceStatusDesired | undefined;
    shadowVersion?: number | undefined;
    timestamp?: Date | undefined;
    reportedFirmwareTimestamp?: Date | undefined;
}

export class DeviceStatusDesired implements IDeviceStatusDesired {
    firmwareId?: string | undefined;
    firmware?: string | undefined;

    constructor(data?: IDeviceStatusDesired) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firmwareId = _data["firmwareId"];
            this.firmware = _data["firmware"];
        }
    }

    static fromJS(data: any): DeviceStatusDesired {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusDesired();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmwareId"] = this.firmwareId;
        data["firmware"] = this.firmware;
        return data;
    }
}

export interface IDeviceStatusDesired {
    firmwareId?: string | undefined;
    firmware?: string | undefined;
}

export class DeviceStatusReported implements IDeviceStatusReported {
    firmware?: string | undefined;
    captureTime?: Date | undefined;
    lastConnect?: Date | undefined;
    deviceTime?: Date | undefined;
    batteryLevel?: number | undefined;
    imageRemaining?: number | undefined;
    imageSerialNumber?: number | undefined;
    totalImagesCount?: number | undefined;
    connection?: string | undefined;
    wifiTime?: number | undefined;
    rssi?: number | undefined;

    constructor(data?: IDeviceStatusReported) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firmware = _data["firmware"];
            this.captureTime = _data["captureTime"] ? new Date(_data["captureTime"].toString()) : <any>undefined;
            this.lastConnect = _data["lastConnect"] ? new Date(_data["lastConnect"].toString()) : <any>undefined;
            this.deviceTime = _data["deviceTime"] ? new Date(_data["deviceTime"].toString()) : <any>undefined;
            this.batteryLevel = _data["batteryLevel"];
            this.imageRemaining = _data["imageRemaining"];
            this.imageSerialNumber = _data["imageSerialNumber"];
            this.totalImagesCount = _data["totalImagesCount"];
            this.connection = _data["connection"];
            this.wifiTime = _data["wifiTime"];
            this.rssi = _data["rssi"];
        }
    }

    static fromJS(data: any): DeviceStatusReported {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceStatusReported();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmware"] = this.firmware;
        data["captureTime"] = this.captureTime ? this.captureTime.toISOString() : <any>undefined;
        data["lastConnect"] = this.lastConnect ? this.lastConnect.toISOString() : <any>undefined;
        data["deviceTime"] = this.deviceTime ? this.deviceTime.toISOString() : <any>undefined;
        data["batteryLevel"] = this.batteryLevel;
        data["imageRemaining"] = this.imageRemaining;
        data["imageSerialNumber"] = this.imageSerialNumber;
        data["totalImagesCount"] = this.totalImagesCount;
        data["connection"] = this.connection;
        data["wifiTime"] = this.wifiTime;
        data["rssi"] = this.rssi;
        return data;
    }
}

export interface IDeviceStatusReported {
    firmware?: string | undefined;
    captureTime?: Date | undefined;
    lastConnect?: Date | undefined;
    deviceTime?: Date | undefined;
    batteryLevel?: number | undefined;
    imageRemaining?: number | undefined;
    imageSerialNumber?: number | undefined;
    totalImagesCount?: number | undefined;
    connection?: string | undefined;
    wifiTime?: number | undefined;
    rssi?: number | undefined;
}

export class EmailReportResult implements IEmailReportResult {
    recipient?: string | undefined;
    isSent?: boolean | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IEmailReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.isSent = _data["isSent"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): EmailReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["isSent"] = this.isSent;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IEmailReportResult {
    recipient?: string | undefined;
    isSent?: boolean | undefined;
    errorMessage?: string | undefined;
}

export class FirmwareHistoryModel implements IFirmwareHistoryModel {
    firmware?: string | undefined;
    assignedDate?: Date | undefined;
    updatedDate?: Date | undefined;
    connection?: string | undefined;
    readonly isManualFlash?: boolean | undefined;
    order?: number | undefined;

    constructor(data?: IFirmwareHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firmware = _data["firmware"];
            this.assignedDate = _data["assignedDate"] ? new Date(_data["assignedDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.connection = _data["connection"];
            (<any>this).isManualFlash = _data["isManualFlash"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): FirmwareHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmware"] = this.firmware;
        data["assignedDate"] = this.assignedDate ? this.assignedDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["connection"] = this.connection;
        data["isManualFlash"] = this.isManualFlash;
        data["order"] = this.order;
        return data;
    }
}

export interface IFirmwareHistoryModel {
    firmware?: string | undefined;
    assignedDate?: Date | undefined;
    updatedDate?: Date | undefined;
    connection?: string | undefined;
    isManualFlash?: boolean | undefined;
    order?: number | undefined;
}

export class FirmwareInfo implements IFirmwareInfo {
    name?: string | undefined;
    dateModify?: Date | undefined;
    isDefault?: boolean | undefined;
    fileName?: string | undefined;
    fileAsBase64?: string | undefined;

    constructor(data?: IFirmwareInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dateModify = _data["dateModify"] ? new Date(_data["dateModify"].toString()) : <any>undefined;
            this.isDefault = _data["isDefault"];
            this.fileName = _data["fileName"];
            this.fileAsBase64 = _data["fileAsBase64"];
        }
    }

    static fromJS(data: any): FirmwareInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dateModify"] = this.dateModify ? this.dateModify.toISOString() : <any>undefined;
        data["isDefault"] = this.isDefault;
        data["fileName"] = this.fileName;
        data["fileAsBase64"] = this.fileAsBase64;
        return data;
    }
}

export interface IFirmwareInfo {
    name?: string | undefined;
    dateModify?: Date | undefined;
    isDefault?: boolean | undefined;
    fileName?: string | undefined;
    fileAsBase64?: string | undefined;
}

export class FleetIndexResponse implements IFleetIndexResponse {
    data?: Device[] | undefined;
    nextToken?: string | undefined;

    constructor(data?: IFleetIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Device.fromJS(item));
            }
            this.nextToken = _data["nextToken"];
        }
    }

    static fromJS(data: any): FleetIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FleetIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["nextToken"] = this.nextToken;
        return data;
    }
}

export interface IFleetIndexResponse {
    data?: Device[] | undefined;
    nextToken?: string | undefined;
}

export class ModelError implements IModelError {
    exception?: any | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IModelError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exception = _data["exception"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ModelError {
        data = typeof data === 'object' ? data : {};
        let result = new ModelError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exception"] = this.exception;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IModelError {
    exception?: any | undefined;
    errorMessage?: string | undefined;
}

export class ModelStateEntry implements IModelStateEntry {
    rawValue?: any | undefined;
    attemptedValue?: string | undefined;
    readonly errors?: ModelError[] | undefined;
    validationState?: ModelValidationState | undefined;
    readonly isContainerNode?: boolean | undefined;
    readonly children?: ModelStateEntry[] | undefined;

    constructor(data?: IModelStateEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawValue = _data["rawValue"];
            this.attemptedValue = _data["attemptedValue"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(ModelError.fromJS(item));
            }
            this.validationState = _data["validationState"];
            (<any>this).isContainerNode = _data["isContainerNode"];
            if (Array.isArray(_data["children"])) {
                (<any>this).children = [] as any;
                for (let item of _data["children"])
                    (<any>this).children!.push(ModelStateEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelStateEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ModelStateEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawValue"] = this.rawValue;
        data["attemptedValue"] = this.attemptedValue;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["validationState"] = this.validationState;
        data["isContainerNode"] = this.isContainerNode;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelStateEntry {
    rawValue?: any | undefined;
    attemptedValue?: string | undefined;
    errors?: ModelError[] | undefined;
    validationState?: ModelValidationState | undefined;
    isContainerNode?: boolean | undefined;
    children?: ModelStateEntry[] | undefined;
}

export enum ModelValidationState {
    Unvalidated = "Unvalidated",
    Invalid = "Invalid",
    Valid = "Valid",
    Skipped = "Skipped",
}

export class RegisterBulkRequest implements IRegisterBulkRequest {
    groupName!: string;
    deviceType!: string;
    advertiserId?: string | undefined;
    count?: number | undefined;
    description!: string;
    userEmail!: string;
    adminUserId?: string | undefined;

    constructor(data?: IRegisterBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.deviceType = _data["deviceType"];
            this.advertiserId = _data["advertiserId"];
            this.count = _data["count"];
            this.description = _data["description"];
            this.userEmail = _data["userEmail"];
            this.adminUserId = _data["adminUserId"];
        }
    }

    static fromJS(data: any): RegisterBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["deviceType"] = this.deviceType;
        data["advertiserId"] = this.advertiserId;
        data["count"] = this.count;
        data["description"] = this.description;
        data["userEmail"] = this.userEmail;
        data["adminUserId"] = this.adminUserId;
        return data;
    }
}

export interface IRegisterBulkRequest {
    groupName: string;
    deviceType: string;
    advertiserId?: string | undefined;
    count?: number | undefined;
    description: string;
    userEmail: string;
    adminUserId?: string | undefined;
}

export class RegisterBulkResponse implements IRegisterBulkResponse {
    zipPassword?: string | undefined;
    zipPresignedUrl?: string | undefined;
    requestorEmail?: EmailReportResult | undefined;
    notificationGroupEmail?: EmailReportResult | undefined;

    constructor(data?: IRegisterBulkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zipPassword = _data["zipPassword"];
            this.zipPresignedUrl = _data["zipPresignedUrl"];
            this.requestorEmail = _data["requestorEmail"] ? EmailReportResult.fromJS(_data["requestorEmail"]) : <any>undefined;
            this.notificationGroupEmail = _data["notificationGroupEmail"] ? EmailReportResult.fromJS(_data["notificationGroupEmail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterBulkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBulkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zipPassword"] = this.zipPassword;
        data["zipPresignedUrl"] = this.zipPresignedUrl;
        data["requestorEmail"] = this.requestorEmail ? this.requestorEmail.toJSON() : <any>undefined;
        data["notificationGroupEmail"] = this.notificationGroupEmail ? this.notificationGroupEmail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRegisterBulkResponse {
    zipPassword?: string | undefined;
    zipPresignedUrl?: string | undefined;
    requestorEmail?: EmailReportResult | undefined;
    notificationGroupEmail?: EmailReportResult | undefined;
}

export class RegisterBulkResponseStateMachineExecutionResult implements IRegisterBulkResponseStateMachineExecutionResult {
    result?: RegisterBulkResponse | undefined;
    status!: StateMachineExecutionStatus;
    failedReason?: string | undefined;

    constructor(data?: IRegisterBulkResponseStateMachineExecutionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? RegisterBulkResponse.fromJS(_data["result"]) : <any>undefined;
            this.status = _data["status"];
            this.failedReason = _data["failedReason"];
        }
    }

    static fromJS(data: any): RegisterBulkResponseStateMachineExecutionResult {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBulkResponseStateMachineExecutionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["failedReason"] = this.failedReason;
        return data;
    }
}

export interface IRegisterBulkResponseStateMachineExecutionResult {
    result?: RegisterBulkResponse | undefined;
    status: StateMachineExecutionStatus;
    failedReason?: string | undefined;
}

export class RegisterDeviceRequest implements IRegisterDeviceRequest {
    macAddress?: string | undefined;
    groupName?: string | undefined;
    deviceType?: string | undefined;

    constructor(data?: IRegisterDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.macAddress = _data["macAddress"];
            this.groupName = _data["groupName"];
            this.deviceType = _data["deviceType"];
        }
    }

    static fromJS(data: any): RegisterDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["macAddress"] = this.macAddress;
        data["groupName"] = this.groupName;
        data["deviceType"] = this.deviceType;
        return data;
    }
}

export interface IRegisterDeviceRequest {
    macAddress?: string | undefined;
    groupName?: string | undefined;
    deviceType?: string | undefined;
}

export class RegisterDeviceResponse implements IRegisterDeviceResponse {
    macAddress?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    pem?: string | undefined;

    constructor(data?: IRegisterDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.macAddress = _data["macAddress"];
            this.publicKey = _data["publicKey"];
            this.privateKey = _data["privateKey"];
            this.pem = _data["pem"];
        }
    }

    static fromJS(data: any): RegisterDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["macAddress"] = this.macAddress;
        data["publicKey"] = this.publicKey;
        data["privateKey"] = this.privateKey;
        data["pem"] = this.pem;
        return data;
    }
}

export interface IRegisterDeviceResponse {
    macAddress?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    pem?: string | undefined;
}

export class RegistrationGroup implements IRegistrationGroup {
    name?: string | undefined;
    description?: string | undefined;
    deviceType?: string | undefined;
    advertiserId?: string | undefined;
    deviceCount?: number | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IRegistrationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.deviceType = _data["deviceType"];
            this.advertiserId = _data["advertiserId"];
            this.deviceCount = _data["deviceCount"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RegistrationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["deviceType"] = this.deviceType;
        data["advertiserId"] = this.advertiserId;
        data["deviceCount"] = this.deviceCount;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRegistrationGroup {
    name?: string | undefined;
    description?: string | undefined;
    deviceType?: string | undefined;
    advertiserId?: string | undefined;
    deviceCount?: number | undefined;
    createdAt?: Date | undefined;
}

export enum StateMachineExecutionStatus {
    Running = "Running",
    Error = "Error",
    Completed = "Completed",
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new SwaggerException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}